// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock___W1Oa","validationTips":"StatementDescriptor_validationTips__374P_"};